import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SignInSignUp from './SignInSignUp';
import appActions from './AppActions';

class SignInSignUpContainer extends React.Component {
  componentWillMount() {
    this.props.switchTab(this.props.defaultTab);
  }

  render() {
    return (
      this.props.selectedTab != null &&
      (
        <SignInSignUp
          selectedTab={this.props.selectedTab}
          switchTab={this.props.switchTab}
          forgotPasswordPath={this.props.forgotPasswordPath}
          customer={this.props.customer}
          onSigninSuccess={this.props.onSigninSuccess}
          onRegistrationSuccess={this.props.onRegistrationSuccess}
          showSignIn={this.props.showSignIn}
          showSignUp={this.props.showSignUp}
          signInLabel={this.props.signInLabel}
          signUpLabel={this.props.signUpLabel}
          signInLabelClassNameOverride={this.props.signInLabelClassNameOverride}
          signUpLabelClassNameOverride={this.props.signUpLabelClassNameOverride}
          signInLabelDivClassNameOverride={this.props.signInLabelDivClassNameOverride}
          signUpLabelDivClassNameOverride={this.props.signUpLabelDivClassNameOverride}
          showAlreadyHaveAccount={this.props.showAlreadyHaveAccount}
          finishCreatingAccount={this.props.finishCreatingAccount}
          accountInvitationGuid={this.props.accountInvitationGuid}
          showAccountBenefitsText={this.props.showAccountBenefitsText}
          showSignUpBorderBottom={this.props.showSignUpBorderBottom}
          signUpTitleElementType={this.props.signUpTitleElementType}
        />
      )
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    selectedTab: state.app.selectedTab,
    forgotPasswordPath: ownProps.forgotPasswordPath,
    customer: ownProps.customer,
    onSigninSuccess: ownProps.onSigninSuccess,
    onRegistrationSuccess: ownProps.onRegistrationSuccess,
    showAlreadyHaveAccount: ownProps.showAlreadyHaveAccount,
    accountInvitationGuid: ownProps.accountInvitationGuid,
    showAccountBenefitsText: ownProps.showAccountBenefitsText,
    showSignUpBorderBottom: ownProps.showSignUpBorderBottom,
    signUpTitleElementType: ownProps.signUpTitleElementType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    switchTab: tab => dispatch(appActions(tab)),
  };
}

SignInSignUpContainer.defaultProps = {
  forgotPasswordPath: '',
  customer: {},
  defaultTab: 'signIn',
  showSignIn: true,
  showSignUp: true,
  signInLabel: 'Sign In',
  signUpLabel: 'Create an Account',
  signInLabelClassNameOverride: undefined,
  signUpLabelClassNameOverride: undefined,
  signInLabelDivClassNameOverride: undefined,
  signUpLabelDivClassNameOverride: undefined,
  showAlreadyHaveAccount: true,
  finishCreatingAccount: false,
  accountInvitationGuid: undefined,
  showAccountBenefitsText: true,
  showSignUpBorderBottom: true,
  signUpTitleElementType: 'div',
};

SignInSignUpContainer.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  switchTab: PropTypes.func.isRequired,
  defaultTab: PropTypes.string,
  forgotPasswordPath: PropTypes.string,
  customer: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
  onSigninSuccess: PropTypes.func.isRequired,
  onRegistrationSuccess: PropTypes.func.isRequired,
  showSignIn: PropTypes.bool,
  showSignUp: PropTypes.bool,
  signInLabel: PropTypes.string,
  signUpLabel: PropTypes.string,
  signInLabelClassNameOverride: PropTypes.string,
  signUpLabelClassNameOverride: PropTypes.string,
  signInLabelDivClassNameOverride: PropTypes.string,
  signUpLabelDivClassNameOverride: PropTypes.string,
  showAlreadyHaveAccount: PropTypes.bool,
  finishCreatingAccount: PropTypes.bool,
  accountInvitationGuid: PropTypes.string,
  showAccountBenefitsText: PropTypes.bool,
  showSignUpBorderBottom: PropTypes.bool,
  signUpTitleElementType: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInSignUpContainer);
